import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MachineInfoComponent } from "./machine-info.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  DxButtonModule,
  DxDataGridModule,
  DxFormModule,
  DxLoadIndicatorModule,
  DxSelectBoxModule
} from "devextreme-angular";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardWithForcedLogin, PipesModule } from 'acl-cloud-lib';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {VisibleForRolesDirective} from "../../core/auth/visible-for-roles.directive";
import {EnableForRolesDirective} from "../../core/auth/enable-for-roles.directive";

const routes: Routes = [
  {
    path: '',
    component: MachineInfoComponent,
    canActivate: [AuthGuardWithForcedLogin],
    data: { breadcrumb: 'Machines' }
  },
  {
    path: 'byState',
    component: MachineInfoComponent,
    canActivate: [AuthGuardWithForcedLogin],
    data: { breadcrumb: 'Machines' }
  }
];

@NgModule({
  declarations: [
    MachineInfoComponent,
  ],
  imports: [
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxDataGridModule,
    DxFormModule,
    CommonModule,
    RouterModule.forChild(routes),
    PipesModule,
    DxLoadIndicatorModule,
    VisibleForRolesDirective,
    EnableForRolesDirective
  ],
  providers: [
  ]
})
export class MachineInfoModule { }
